import queryString from 'query-string';

import { UrlHashItemValue } from 'lib/hooks/useHashLocation';
import { SrpFilterApiParams } from 'lib/srpFilterTransformers';

export function cleanKeys(vals: Record<string, UrlHashItemValue>): string {
  const cleaned: Record<string, UrlHashItemValue> = {};
  Object.entries(vals).forEach(([key, val]) => {
    if (vals[key] !== undefined && vals[key] !== '') {
      cleaned[key] = val;
    }
  });
  return queryString.stringify(cleaned, { arrayFormat: 'bracket' });
}

interface FilterParams {
  [key: string]: any;
}

export function filterEmptyNullParams(params: FilterParams): SrpFilterApiParams {
  return Object.fromEntries(
    Object.entries(params)
      .sort()
      .filter(
        ([, v]) =>
          !(v === null || v === undefined || v === false || (Array.isArray(v) && !v.length))
      )
  );
}
